import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import GallerySection from './components/GallerySection';
import ServiceAreaMap from './components/ServiceAreaMap';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';

const HomePage = () => (
  <div className="min-h-screen bg-brand-dark font-sans">
    <Navbar />
    <main>
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <GallerySection />
      <ServiceAreaMap />
      <TestimonialsSection />
      <ContactSection />
    </main>
    <Footer />
  </div>
);

export default HomePage;
